import MessageIcon from '@/components/icons/MessageIcon';
import NotifictionsIcon from '@/components/icons/NotifictionsIcon';
import { Input } from '@/components/ui/input';
import userImage from '@/assets/imgs/user.png';
import SearchIcon from '@/components/icons/Search';
import { useAppSelector } from '@/core/global-store';

const Header = () => {
    const user = useAppSelector((state) => state.auth.user);

    return (
        <header className="bg-primery-blue-500 px-8 py-4 flex flex-row justify-between items-center h-16">
            <div className="flex flex-row items-center bg-primery-blue-600 md:w-80 lg:w-96 xl:w-[540px] h-[46px] px-4 py-2 rounded-[8px]">
                <Input
                    placeholder="ابحث برقم الطلب، اسم العميل، أو نوع المركبة......"
                    className="text-primery-blue-300 text-xs md:text-xs lg:text-base lg:leading-[30px] border-none outline-none focus-visible:ring-0 placeholder:text-primery-blue-300"
                />
                <button className="bg-transparent border-none">
                    <SearchIcon className="text-primery-blue-300" />
                </button>
            </div>
            <div className="flex flex-row items-center gap-6">
                <div className="flex flex-row items-center gap-6">
                    <MessageIcon />
                    <NotifictionsIcon />
                </div>
                <div className="flex flex-row items-center gap-2 xl:pe-5">
                    <img src={userImage} alt="profile" />
                    <div className="text-white-blue-50 xl:pe-11 flex flex-col gap-2 items-start">
                        <p className="font-medium text-sm leading-[14px]">{user?.name}</p>
                        <p className="font-medium text-primery-blue-100 text-xs leading-[13.8px]">{user?.role}</p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
